var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"duration-picker"},[_vm._v("\n  TODO\n")])}
var staticRenderFns = []

export { render, staticRenderFns }